import { forwardRef, useState } from 'react'

import { Container, TextContainer } from 'components/container'
import { Title } from 'components/misc'
import { Details } from 'components/details'
import { AnimatedFigcaption } from 'components/animated-figcaption'
import { Section } from 'components/misc'
import DetailsImage from './assets/Utka 2.webp'
import Image from './assets/Image1.png'
import {
  GraphicsDescription,
  GraphicsImage,
  ImageWrapper,
  SmallGraphics,
} from './styled'

export const War = forwardRef<HTMLDivElement, {}>((_, ref) => {
  const [isExpanded, setExpanded] = useState(false)

  return (
    <Section ref={ref}>
      <TextContainer>
        <Title data-menu-title="война и буряты">Бурятия и война</Title>
        <p>
          Полномасштабное вторжение России в Украину значительно отразилось на
          Бурятии. Сегодня она находится в первой десятке регионов по количеству
          погибших на войне в Украине – и это только в абсолютных числах.
          Журналисты "Медиазоны" и "Би-би-си" смогли независимо{' '}
          <a
            href="https://zona.media/casualties"
            target="_blank"
            rel="noreferrer"
          >
            подтвердить
          </a>{' '}
          имена свыше 1100 жителей региона, погибших в Украине, но говорят, что
          в реальности их может быть гораздо больше. Для региона, численность
          населения которого не превышает и миллиона человек, это масштабные
          потери. Притом что буряты составляют около 0,3% от населения России, в
          армии их число превышает 1%. Более того, за последние два года общая
          численность населения в республике, по{' '}
          <a
            href="https://rosstat.gov.ru/compendium/document/13282"
            target="_blank"
            rel="noreferrer"
          >
            данным
          </a>{' '}
          Росстата, сократилась почти на 4 тысячи человек – это рекордный
          показатель.
        </p>
        <p>
          Правозащитники говорят, что на такое количество военных из Бурятии,
          участвующих в военных действиях против Украины, повлиял низкий уровень
          жизни населения и отсутствие экономического развития региона в целом.
          Только по официальным{' '}
          <a
            href="https://www.baikal-daily.ru/news/15/458826/"
            target="_blank"
            rel="noreferrer"
          >
            данным
          </a>{' '}
          , почти 20% жителей региона находятся за чертой бедности. Несмотря на
          это, республиканские власти{' '}
          <a
            href="https://www.baikal-daily.ru/news/15/451061/"
            target="_blank"
            rel="noreferrer"
          >
            выделили
          </a>{' '}
          из своего бюджета свыше двух миллиардов рублей на поддержку войны.
        </p>
        <p>
          Война стала источником дохода для многих семей. Подписав контракт,
          любой мужчина получает гарантированную и высокую по меркам Бурятии
          зарплату. Но что еще важнее для местных – льготную военную ипотеку.
        </p>

        <ImageWrapper $isExpanded={isExpanded}>
          <div>
            <img src={DetailsImage} alt="" />
          </div>
        </ImageWrapper>
      </TextContainer>

      <Details onToggle={setExpanded}>
        <TextContainer>
          <p>
            "Путин специально всех подсадил на военную ипотеку. И многие не
            могли даже разорвать контракт. Бурятия перевыполнила план по
            мобилизации в 2,5-3 раза благодаря главе республики Алексею
            Цыденову. Людей хватали просто всех. Устраивали облавы", – говорит
            антивоенная активистка из Бурятии Виктория Маладаева.
          </p>
          <p>
            Вместе с этим появились и свидетельства, что военные преступления в
            Украине во время оккупации совершают в том числе этнические буряты в
            составе российской армии. Тогда и в украинских, и в российских СМИ
            вспомнили формулировку – "боевые буряты".
          </p>
          <p>
            Кремль до сих пор отрицает, что на протяжении восьми лет до
            полномасштабного вторжения России в Украину российские военные были
            на территории страны. Но журналистам удалось доказать обратное.
            Одним из ключевых доказательств стало{' '}
            <a
              href="https://novayagazeta.ru/articles/2015/03/02/63264-171-my-vse-znali-na-chto-idem-i-chto-mozhet-byt-187"
              target="_blank"
              rel="noreferrer"
            >
              интервью
            </a>{' '}
            "Новой газеты" с раненым танкистом из Бурятии, который рассказал о
            том, как именно российские власти отправляли контрактников на войну.
            После этого активисты прокремлевского движения "Сеть"{' '}
            <a
              href="https://www.newsru.com/russia/14jul2015/bbputina.html"
              target="_blank"
              rel="noreferrer"
            >
              опубликовали
            </a>{' '}
            видео под названием "Обращение боевых бурят Путина к перепуганным
            жителям Украины", в котором пытались убедить, что бурят в Украине
            нет, но они будут готовы "помочь" Украине в любой момент. Позже
            видео удалили, но выражение закрепилось.
          </p>
          <p>
            Бурятские правозащитники считают эту формулировку ксенофобной и
            пропагандистской. Например, несмотря на то, что несколько человек из
            Бурятии были в составе бригад российской армии, которые оккупировали
            Киевскую область в 2022 году и совершали военные преступления, в СМИ
            в основном упоминают только бурятов.
          </p>
          <p>
            "Понятно, что буряты как один из народов России участвует в этой
            войне, как и все другие 190 народов. Но требовать от нас
            ответственности – это расизм. Мы – меньшинство, нас всего 0,3% [от
            всего населения России]. Мы хотим очистить наше имя. Поэтому мы
            боремся с этой пропагандой, в том числе со стороны российской
            либеральной оппозиции", – говорит Виктория Маладаева.
          </p>
          <p>
            Российские провластные медиа, в попытке дистанцироваться от
            обвинений в военных преступлениях, делают упор на то, что их
            совершали буряты из-за "нецивилизованности",{' '}
            <a
              href="https://doxa.team/articles/free-buryatia"
              target="_blank"
              rel="noreferrer"
            >
              пишет
            </a>{' '}
            исследовательница правозащитного фонда "Свободная Бурятия" Мария
            Вьюшкова: "Перекладывать всю ответственность на национальные
            меньшинства – это ксенофобия. &lt;...&gt; Давайте не будем забывать
            о том, что в России принято вспоминать о других народах, только
            когда их нужно в чем-то обвинить или когда, например, дагестанцы
            выигрывают золото на Олимпиадах – они сразу становятся "великими
            сынами России". Мы провели{' '}
            <a
              href="https://www.instagram.com/p/CgteV7uMtUx/"
              target="_blank"
              rel="noreferrer"
            >
              анализ
            </a>{' '}
            национального состава погибших с российской стороны на этой войне.
            Нет никакой сенсации: абсолютное большинство русских. Но многие
            россияне подвержены когнитивному искажению, связанному с этническим
            восприятием преступности".
          </p>
          <p>
            Среди жителей Бурятии также есть и те, кто активно выступает против
            войны. Но часто против них{' '}
            <a
              href="https://www.currenttime.tv/a/kak-aktivistov-v-buryatii-presleduyut-za-antivoennye-vystupleniya/32729566.html"
              rel="noreferrer"
            >
              заводят
            </a>{' '}
            административные и уголовные дела или же вынуждают покинуть Россию.
            Существуют и организации, которые помогают военнообязанным избежать
            отправки на войну в Украину или преследования за политическую
            позицию. Именно в Бурятии появилось одно из самых заметных
            антивоенных движений – "Свободная Бурятия", его активисты говорят не
            только о необходимости остановить войну, но и колониальной политике
            Москвы по отношению к национальным республикам. Минюст России внес
            фонд "Свободная Бурятия" и его соосновательницу Александру
            Гармажапову в реестр "иностранных агентов".
          </p>
        </TextContainer>
      </Details>

      <Container>
        <SmallGraphics>
          <GraphicsImage src={Image} alt="" />
          <AnimatedFigcaption
            FigCaptionComponent={GraphicsDescription}
            description='Yлзы хээ или "узел счастья" символизирует бесконечность, счастье и пожелание благополучия '
          />
        </SmallGraphics>
      </Container>
    </Section>
  )
})
